import { useEffect, useEffectEvent, useMemo } from 'react'
import { useSelector } from '@/libs/state'
import { listAllMembers } from '../application/list-all-members'
import { members$ } from '../store'
import { workflows as workflowsPort, notify } from '../wiring'

// Loads the full member directory once and exposes an id -> name map, so the
// board can render an assignee's display name from the user ID stored on a work
// item. Follows the same store-backed fetch pattern as useWorkItems.
const useAllMembers = () => {
	const members = useSelector(members$)

	const reload = useEffectEvent(async () => {
		members$.set(await listAllMembers(workflowsPort, notify))
	})

	useEffect(() => {
		if (members$.get().length === 0) reload()
	}, [])

	const memberNameById = useMemo(() => {
		const map = new Map<string, string>()
		for (const member of members) map.set(member.id, member.name)
		return map
	}, [members])

	const memberAvatarById = useMemo(() => {
		const map = new Map<string, string>()
		for (const member of members) {
			if (member.avatarUrl) map.set(member.id, member.avatarUrl)
		}
		return map
	}, [members])

	return { memberNameById, memberAvatarById }
}

export { useAllMembers }
